// extracted by mini-css-extract-plugin
export default {"root":"ft-loading_root__OLLuz","loading":"ft-loading_loading__lR+3e","text":"ft-loading_text__a2-tc"};